<div class="dialog-header">
  <span class="dialog-title">Edit {{data.type | titlecase}}</span>
  <span class="material-symbols-outlined close-button" (click)="dialogRef.close()">close</span>
</div>

<div class="dialog-content">
  <div class="field">
    <label class="field__label">{{data.type | titlecase}} Name</label>
    <input class="field__input" type="text" [(ngModel)]="data.friendlyName" #nameCtrl="ngModel" required>
  </div>

  <!-- Default User Markup -->
  <div class="form-card">
    <div class="form-card__header">
      <span class="form-card__title">Default User Markup</span>
    </div>
    <div class="form-card__body">
      <div class="field field--toggle">
        <span class="toggle-label">Inherit values from {{inheritFromDisplay()}}</span>
        <div class="toggle-switch" [class.toggle-switch--on]="data.defaultUserMarkup.useInheritedValues"
          (click)="data.defaultUserMarkup.useInheritedValues = !data.defaultUserMarkup.useInheritedValues">
          <div class="toggle-switch__thumb"></div>
        </div>
      </div>

      @if (!data.defaultUserMarkup.useInheritedValues) {
      <div class="field">
        <label class="field__label">Percentage Cost Per Transaction</label>
        <div class="field__input-suffix">
          <input type="number" step="0.01" [(ngModel)]="muTransRatePercent" [ngModelOptions]="{standalone: true}"
            [min]="0">
          <span class="field__suffix">%</span>
        </div>
      </div>
      <div class="field">
        <label class="field__label">Cost Per Transaction</label>
        <div class="field__input-prefix">
          <span class="field__prefix">$</span>
          <input currencyMask [(ngModel)]="data.defaultUserMarkup.costPerTrans" [min]="0">
        </div>
      </div>
      <div class="field">
        <label class="field__label">Fixed Additional Monthly Fees Total</label>
        <div class="field__input-prefix">
          <span class="field__prefix">$</span>
          <input currencyMask [(ngModel)]="data.defaultUserMarkup.fixedMonthlyFeeTotal" [min]="0">
        </div>
      </div>
      }
    </div>
  </div>

  <!-- Default User Commission -->
  <div class="form-card">
    <div class="form-card__header">
      <span class="form-card__title">Default User Commission</span>
    </div>
    <div class="form-card__body">
      <div class="field field--toggle">
        <span class="toggle-label">Inherit value from {{inheritFromDisplay()}}</span>
        <div class="toggle-switch" [class.toggle-switch--on]="data.defaultUserCommission.useInheritedValues"
          (click)="data.defaultUserCommission.useInheritedValues = !data.defaultUserCommission.useInheritedValues">
          <div class="toggle-switch__thumb"></div>
        </div>
      </div>

      @if (!data.defaultUserCommission.useInheritedValues) {
      <div class="field">
        <label class="field__label">Sales Commission Percent</label>
        <div class="field__input-suffix">
          <input type="number" [(ngModel)]="salesCommissPercent" [ngModelOptions]="{standalone: true}" [min]="0">
          <span class="field__suffix">%</span>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<div class="dialog-actions">
  <button class="cancel-button" mat-dialog-close type="button">Cancel</button>
  <button class="save-button" type="button" (click)="save()">Submit</button>
</div>